// Guide §0.1 / §6.4 FeatureFlag + Bible 12.1 rule 10: these ship OFF. Admin (Super Admin only) flips them.
export const FEATURE_FLAG_KEYS = [
  'zakat', // E6: Shariah sign-off pending
  'medicine_autofill', // E5: data licence pending
  'statement_import', // E7: real MFS statement files pending (R1.1)
  'auto_pay', // E2: gateway recurring pending — UI/FAQ hidden while OFF
  'personal_insights', // R1.1 Personal DukanIQ
] as const;
export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[number];

export const FEATURE_FLAG_DEFAULTS: Record<FeatureFlagKey, boolean> = {
  zakat: false,
  medicine_autofill: false,
  statement_import: false,
  auto_pay: false,
  personal_insights: false,
};

export type FeatureFlags = Record<FeatureFlagKey, boolean>;

export const FEATURE_FLAG_DESCRIPTION: Record<FeatureFlagKey, string> = {
  zakat: 'Zakat calculator (needs Shariah Adviser sign-off — E6)',
  medicine_autofill: 'Medicine database & smart autofill (needs data licence — E5)',
  statement_import: 'MFS daily statement import (R1.1, needs real provider files — E7)',
  auto_pay: 'Auto-debit renewals (needs gateway recurring confirmation — E2)',
  personal_insights: 'Personal Space DukanIQ insights (R1.1)',
};

export interface FlagRule {
  /** If set, flag is on only for these accounts even when `enabled` is false (gradual rollout, Guide §6.4) */
  accountIds?: string[];
  categories?: string[];
}

/** Evaluate a flag for an account/category given the DB row (enabled + optional rules). */
export function flagOn(
  row: { enabled: boolean; rules?: FlagRule | null } | undefined,
  ctx: { accountId?: string; category?: string },
): boolean {
  if (!row) return false;
  if (row.enabled) return true;
  const r = row.rules;
  if (!r) return false;
  if (r.accountIds?.length && ctx.accountId && r.accountIds.includes(ctx.accountId)) return true;
  if (r.categories?.length && ctx.category && r.categories.includes(ctx.category)) return true;
  return false;
}
